import graphqlClient from "../../../apollo";

class ModeloProvider {

    findModelo(id) {
        return graphqlClient.query({
            query: require('./gql/modeloFind.graphql'),
            variables: { id: id },
            fetchPolicy: "network-only"
        })
    }

    fetchModelos(marca) {
        return graphqlClient.query({
            query: require('./gql/modeloFetch.graphql'),
            variables: { marca },
            fetchPolicy: "network-only"
        })
    }

    paginateModelos(pageNumber, itemsPerPage, search = null, orderBy = null, orderDesc = false) {
        return graphqlClient.query({
            query: require('./gql/modeloPaginate.graphql'),
            variables: { pageNumber, itemsPerPage, search, orderBy, orderDesc },
            fetchPolicy: "network-only"
        })
    }

    getModeloUpdateImpact(modeloId) {
        return graphqlClient.query({
            query: require('./gql/modeloUpdateImpact.graphql'),
            variables: { modeloId },
            fetchPolicy: "network-only"
        })
    }

    createModelo(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/modeloCreate.graphql'),
            variables: form
        })
    }

    updateModelo(form) {
        return graphqlClient.mutate({
            mutation: require('./gql/modeloUpdate.graphql'),
            variables: form
        })
    }

    deleteModelo(id) {
        return graphqlClient.mutate({
            mutation: require('./gql/modeloDelete.graphql'),
            variables: { id }
        })
    }

}

export default new ModeloProvider()


